import React, { useState } from 'react';
import {ReactComponent as StatusDropdownIcon} from './svgs/statusDropdownIcon.svg';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const StatusDropdown = ({options, dropdownText, className}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };
    
    const dropdownClasses = classNames('status-dropdown', className);

  return (
    <>


    <div className={dropdownClasses}>
        <Link className="dropdown-toggle flex dropdown-title-text" onClick={toggleDropdown}>
            {dropdownText}
            <StatusDropdownIcon/>
        </Link>
        {isOpen && (
        <ul className="dropdown-menu dropdown-links-container">
            {options.map((option, index) => (
            <li key={index} className="dropdown-item">
                <a href={option.link}>{option.label}</a>
            </li>
            ))}
        </ul>
        )}
    </div>

   
    </>
  )
}

export default StatusDropdown